var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    workbench-workpackage
    ${_vm.color}
    ${_vm.text_color}--text
    ${_vm.color.includes('lighten') || _vm.color.includes('darken')? '':'lighten-1'}
    t-rounded
    t-shadow
    font-weight-light

    `,style:(`
    ${_vm.height?`height: ${_vm.height};`:''}
    ${_vm.width?`width: ${_vm.width};`:''}
    ${_vm.margin?`margin: ${_vm.margin};`:''}
  `)},[(!_vm.no_header)?_c('div',{staticClass:"workbench-workpackage-header"},[_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"workbench-workpackage-content",style:(`
      ${_vm.tabs?'box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.2) !important;':''}
      ${_vm.footer?'height: calc(100% - 33px - 30px);':''}
      ${_vm.center_content?'justify-content: center;':''}
    `)},[_vm._t("content")],2),(_vm.footer)?[_c('v-spacer'),_c('div',{staticClass:"workbench-workpackage-footer"},[_vm._t("footer")],2)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }